import { LANDING_PAGE } from "@/constants";
import { getApplicationID } from "./wizard";

const urlWizard = process.env.NEXT_PUBLIC_URL_WIZARD ?? `#`;
const urlUserProfile= process.env.NEXT_PUBLIC_URL_PROFILE ?? `#`;
const urlAgentProfile= process.env.NEXT_PUBLIC_URL_AGENT_PROFILE ?? `#`;
const urlIncidents = process.env.NEXT_PUBLIC_URL_SINIESTROS ?? `#`;
const domain = process.env.NEXT_PUBLIC_DOMAIN ?? `#`;
export const API_BACKEND = process.env.NEXT_PUBLIC_API_BACKEND ?? `#`;

export function classNamesList(...clases: string[]): string {
	return clases.join(' ');
}

export const goToUserProfile = (): void => {
	window.location.href = `${urlUserProfile}`
};

export const goToAgentProfile = (): void => {
	window.location.href = `${urlAgentProfile}`
};

export const goToIncidents = (): void => {
	window.location.href = `${urlIncidents}`;
}

// Nota: Recupera el id de la cotización del localstorage y matine o elimina la cotización activa
export const goToWizardQuote = (newQuote: boolean = false): void => {
	//let url = `${urlWizard}/return-from-landing/${newQuote ? `new` : `plans`}`;

	//window.location.href = `${url}/${getApplicationID()}`;

	window.location.href = `${LANDING_PAGE}/form/cotizacion?clearData=true`;
};
